import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function pisoReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    // const chartSegments = [0, 20, 25, 100];

    async function getChart(conformidade) {

        // let dommax = Math.max(params.meta * 1.2, parseFloat(conformidade) * 1.2);
        // dommax = parseInt(dommax)
        // let dommix = Math.max(params.meta * 0.8, parseFloat(conformidade) * 0.8);
        // dommix = parseInt(dommix)


        const chartSegments = [0, params.meta, parseFloat(params.meta) + 10, 100];
        return h.gaugeChart(
            {
                width: 210,
                height: 130,
                segmentsColors: ["#6bd72d", "#ecdb23", "#fe4719"],
                // maxSegmentLabels: 5,
                customSegmentStops: chartSegments,
                segments: 3,
                series: [{ name: "", values: conformidade }],
            },
            { alignment: "center", colSpan: 3 }
        );
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart);
}
